<template>
  <div class="base-select">
    <!-- Clickable zone -->
    <base-text
      uppercase
      size="s"
      class="mb-1 base-select__label"
      medium
      :class="{'base-select__label--is-open': isOpen}"
    >
      {{ label }}
    </base-text>
    <div class="base-select__button selector rounded">
      <div
        ref="clientList"
        class="
          d-flex
          justify-content-center
          align-items-center
          py-2
          toggle-selector
          base-select__selected
        "
        @click="toggleSelector"
      >
        <base-text
          v-if="value !== null"
          trim
          light
          size="m"
        >
          {{ items[value] }}
        </base-text>

        <div v-if="value === null && placeholder" class="base-select__placeholder">
          {{ placeholder }}
        </div>

        <base-icon
          class="ml-auto"
          icon="arrow-down-m"
        />
      </div>
    </div>
    <!-- Popopver -->
    <transition name="fade">
      <div
        v-if="isOpen"
        v-click-outside="toggleSelector"
        class="base-select__popover"
      >
        <div
          class="base-select__popover-inner"
        >
          <div class="">
            <base-search
              ref="search"
              class="base-select__search"
              :value="search"
              show-icon
              icon="arrow-down-m"
              @input="$emit('on-search', $event)"
            />
          </div>
          <!-- <hr class="base-select__sep"> -->
          <div
            v-scrollable="{
              heightThresholdAdjust: 100
            }"
            class="base-select__content"
            v-on="$listeners"
          >
            <div class="base-select__scrollable">
              <slot v-bind="{items, value, onSelect}">
                <div
                  v-for="(item, index) in items"
                  :key="`clientSelector_${index}`"
                  class="base-select__item"
                  @click="onSelect(index)"
                >
                  <div
                    class="d-flex justify-content-between py-1 px-2"
                    :style="{ cursor: 'pointer' }"
                  >
                    <base-text
                      trim
                      size="s"
                    >
                      {{ item }}
                    </base-text>
                    <base-icon
                      v-if="value === index"
                      icon="colored-check"
                    />
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * base-select
 */
import Scrollable from '@/_utilities/Scrollable';

export default {
  name: 'BaseSelect',
  directives: {
    scrollable: Scrollable,
  },
  props: {
    label: {
      type: String,
      default: 'Label',
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      search: '',
      isOpen: false,
    };
  },
  watch: {
    /**
     * @description State to check if the selector is open
     * @param {Boolean} value
     */
    isOpen(value) {
      if (value) {
        this.$nextTick().then(() => {
          this.$refs.search.focus();
        });
      }
    },
  },
  methods: {
    /**
     * @description When the user selects an option
     * @param {Number} index
     */
    onSelect(index) {
      this.isOpen = false;
      this.$emit('input', index);
    },
    /**
     * @description Open and Closes the selector
     */
    toggleSelector() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-select {
  position: relative;
  // padding: 13px 0;

  &__item{
      transition: all 0.2s;
      // padding-left: 13px;
      // padding-right: 13px;
      &:hover{
          background-color: $clementine;
      }
  }

  &__placeholder{
    @extend %silka;
    font-size: 10px;
    line-height: 12px;
    text-transform: uppercase;
    color: $gray-light-4;
  }

  &__selected{
    min-height: 37px;
  }

  &__content {
    // margin-left: -13px;
    // margin-right: -13px;
    overflow-y: auto;
    max-height: 100%;
  }

  &__label{
    margin-top: 0;
    margin-bottom: 4px;
    transition: all 0.2s;
  }
  &__label--is-open{
    // margin-top: -10px;
    // margin-bottom: 14px !important;
  }

  &__button {
    cursor: pointer;
    border: solid 1px $gray-light-2;
    background: white;
    padding-left: 15px;
    padding-right: 15px;
  }

  &__popover {
    position: absolute;
    z-index: $zindex-modal;
    top: 21px;
    left: 0;
    right: 0;
    // padding: 13px;
    border: solid 1px $gray-light-2;
    border-radius: 5px 5px 0 0;
    background-color: white;
  }
  &__popover-inner {
    // background-color: #ffffff;
    // border: solid 1px #ccc;
    width: 100%;
    display: flex;
    flex-direction: column;
    max-height: 280px;
    font-size: 13px;
    // margin-bottom: 1rem;
  }
  &__search {
      margin-right: 0;
      min-height: 40px;
      &::v-deep .base-search__icon--right {
        right: 15px;
      }
      &::v-deep input {
          border: none;
          border-bottom: solid 1px $gray-light-2;
          border-radius: 5px 5px 0 0;
          background-color: white;
          font-size: 14px;

          &:focus {
              outline: none;
          }

          &::-webkit-input-placeholder{
            text-transform: uppercase;
            font-size: 10px;
            color: $gray-light-4;
          }
      }
  }
  &__sep {
    border-top: 1px solid $gray-light-4;
    margin-left: -13px;
    margin-right: -13px;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: all .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  max-height: 71px;
  overflow: hidden;
}
</style>
